import {Button, Form, Input} from 'antd';
import {jwtDecode} from 'jwt-decode';
import {useState} from 'react';
import {toast} from 'react-hot-toast';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import {RQUserLoginAPI} from '../../../ReactQuery/apis';
import {loginSuccess} from '../../../Redux/authAction';
import {ForgotPasswordScreen} from '../LoginScreen/ForgetPasswordScreen';

const ROLE_HOME_ROUTE = {
  ADMIN: '/admin/dashboard',
  RECEPTIONIST: '/receptionist/dashboard',
  DOCTOR: '/doctor/dashboard',
  THERAPIST: '/therapist/dashboard',
  
};

const LoginScreen = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showForgotPassword, setShowForgotPassword] = useState(false);

  const {mutate: loginUser, isLoading} = RQUserLoginAPI({
    onSuccess: res => {
      if (!res?.token) {
        toast.error('Unexpected response from server');
        return;
      }

      let decoded;

      try {
        decoded = jwtDecode(res.token);
      } catch {
        toast.error('Invalid session token received');
        return;
      }

      // The login response already includes role/id (per the API docs), but
      // fall back to the JWT claim in case a caller only has the token.
      const role = res.role || decoded.role;

      dispatch(loginSuccess({...res, role}));
      toast.success('Login successful');

      const homeRoute = ROLE_HOME_ROUTE[role];

      if (homeRoute) {
        navigate(homeRoute);
      } else {
        toast.error(`Access Denied for role "${role}"`);
      }
    },
    onError: err => {
      if (err?.response?.status === 401) {
        toast.error('Invalid email or password');
      } else if (!err?.response) {
        toast.error('Network error, check connection');
      } else {
        toast.error('Invalid credentials');
      }
    },
  });

  if (showForgotPassword) {
    return <ForgotPasswordScreen setShowForgotPassword={setShowForgotPassword} />;
  }

  const onFinish = values => {
    loginUser(values);
  };

  return (
    <div className={'w-full max-w-sm'}>
      <Form layout={'vertical'} onFinish={onFinish}>
        <Form.Item
          label={<span className={'text-primary-950 font-medium'}>Email</span>}
          name={'email'}
          rules={[
            {required: true, message: 'Email is required'},
            {type: 'email', message: 'Enter valid email'},
          ]}
        >
          <Input placeholder={'Enter email'} />
        </Form.Item>

        <Form.Item
          className={'mb-1'}
          label={<span className={'text-primary-950 font-medium'}>Password</span>}
          name={'password'}
          rules={[
            {required: true, message: 'Password is required'},
          ]}
        >
          <Input.Password placeholder={'Enter password'} />
        </Form.Item>

        <div className={'text-right mb-4'}>
          <Button
            type={'link'}
            onClick={() => setShowForgotPassword(true)}
          >
            Forgot Password?
          </Button>
        </div>

        <Button
          type={'primary'}
          htmlType={'submit'}
          loading={isLoading}
          block
          className={'bg-primary-900 text-primary-50 text-lg font-semibold hover:!bg-primary-900'}
        >
          Login
        </Button>
      </Form>
    </div>
  );
};

export default LoginScreen;
